import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox, DatePicker, Dropdown, Input, Menu, Spin, Pagination } from 'antd';
import MoreMeeting from '../meeting/MoreMeeting';
import moment from 'moment';
import { Axis, Chart, Geom, Guide, Tooltip } from 'bizcharts';

const MenuItem = Menu.Item;
const CheckboxGroup = Checkbox.Group;

const datalist = data => {
  const arr = [];
  data.forEach(item => {
    let roomName = item.roomName;
    let roomNameEn = item.roomNameEn;
    if (roomName && roomName.length > 8) {
      roomName = roomName.substr(0, 8) + '...';
    }
    if (roomNameEn && roomNameEn.length > 8) {
      roomNameEn = roomNameEn.substr(0, 8) + '...';
    }
    arr.push({
      meeting: `${roomName}`,
      roomName: `${roomName}`,
      roomNameEn: `${roomNameEn}`,
      usage: Number(item.usage) > 100 ? 100 : item.usage,
      percent: Number(item.usage) > 100 ? 100 : item.usage
    });
  });
  return arr;
};

const showData = (e, item) => {
  switch (e) {
    case '会议时长':
      return Math.floor((item.meetingLength / 60) * 100) / 100;
    case '参会人名单':
      return item.memberNames && !item.fuNames
        ? item.holderName + ';' + item.memberNames
        : !item.memberNames && item.fuNames
          ? item.holderName + ';' + item.fuNames
          : item.memberNames && item.fuNames
            ? item.holderName + ';' + item.memberNames + ';' + item.fuNames
            : item.holderName;
    case '会议室容量':
      //return item.seat == 1 ? '1-3人' : item.seat == 2 ? '4-9人' : '超过10人';
      return item.minNumber + '-' + item.maxNumber + '人';
    case '签到率':
      return item.signRate + '%';
    case '未签到名单':
      return item.noSignMembers;
    case '弃用':
      return item.isNoUse == 0 ? '是' : '否';
    case '延时':
      return item.isExtend == 0 ? '是' : '否';
    case '提前结束':
      return item.isEndBefore == 0 ? '是' : '否';
    case '预订方式':
      return item.meetingSource == 0
        ? '会议系统'
        : item.meetingSource == 1
          ? '平台预订'
          : item.meetingSource == 2
            ? '手机预订'
            : item.meetingSource == 3
              ? 'Exchange|Outlook'
              : item.meetingSource == 4
                ? 'Domino|Notes'
                : 'GoogleCalendar';
    case '周期会议':
      return item.isRecurring == 0 ? '是' : '否';
  }
};

const tableList = (
  data,
  pageNo,
  dispatch,
  startTime,
  endTime,
  intl,
  roomReport
) => {
  return data.map((item, index) => {
    return (
      <li key={index}>
        <div
          className={
            roomReport.moreMenu.length <= 2
              ? 'tip-case reportTable'
              : roomReport.moreMenu.length <= 6 &&
                roomReport.moreMenu.length > 2
                ? 'tip-case reportTable middle-width-scroll'
                : 'tip-case reportTable max-width-scroll'
          }
        >
          <div className="meeting-index">{item.zoneName}</div>
          <div className="meeting-area">{intl.messages.locale === 'en_US'?item.roomNameEn:item.roomName}</div>
          <div className="meeting-name">
            {moment(item.startDate).format('YYYY-MM-DD')}
          </div>
          <div className="meeting-num">
            {moment(item.meetingStartTime).format('HH:mm') +
              '-' +
              moment(item.meetingEndTime).format('HH:mm')}
          </div>
          <div className="sign-num">{item.meetingName}</div>
          <div className="sign-length">{item.creatorName}</div>
          <div className="meeting-occupy">{item.holderName}</div>
          <div className="meeting-detail">{item.attenderNum}</div>
          <div className="meeting-detail">{item.signNum}</div>
          {/*根据获取到的moreMenu在表格进行添加*/}
          {roomReport.moreMenu &&
            roomReport.moreMenu.map((e, index) => {
              return (
                <div className="meetingMore" key={index}>
                  {/*对传来的e进行判断，分别根据不同的字段进行数据的展示*/}
                  {showData(e, item)}
                </div>
              );
            })}
          {/*<div className="meeting-detail" onClick={() => {*/}
          {/*dispatch({*/}
          {/*type: 'roomReportDetails/clickRoomDetail',*/}
          {/*roomId: item.roomId,*/}
          {/*startTime,*/}
          {/*endTime,*/}
          {/*meetingName: item.roomName*/}
          {/*})*/}
          {/*}}>{intl.formatMessage({id: 'report_detail'})}</div>*/}
        </div>
      </li>
    );
  });
};
export default ({ intl, dispatch, loading, roomReport }) => {
  const handleVisibleChange = flag => {
    dispatch({
      type: 'roomReport/setState',
      payload: { dropVis: flag }
    });
  };
  /**
   * 更多选项选择方法
   */
  const checkOnchage = checkedValues => {
    dispatch({
      type: 'roomReport/setState',
      payload: {
        moreMenu: checkedValues,
        indeterminate:
          !!checkedValues.length &&
          checkedValues.length < roomReport.allMoreMenu.length,
        checkAll: checkedValues.length === roomReport.allMoreMenu.length
      }
    });
  };
  /**
   * 更多选项全选方法
   */
  const onCheckAllChange = e => {
    dispatch({
      type: 'roomReport/setState',
      payload: {
        indeterminate: false,
        checkAll: e.target.checked,
        moreMenu: e.target.checked
          ? roomReport.allMoreMenu.map(e => {
              return intl.formatMessage({ id: e });
            })
          : []
      }
    });
  };
  const menu = (
    <Menu className="roomReport-menu">
      <MenuItem>
        <div>
          <div style={{ borderBottom: '1px solid #E9E9E9' }}>
            <Checkbox
              indeterminate={roomReport.indeterminate}
              onChange={onCheckAllChange}
              checked={roomReport.checkAll}
            >
              {intl.formatMessage({ id: 'all_select' })}
            </Checkbox>
          </div>
          <br />
          <CheckboxGroup
            options={roomReport.allMoreMenu.map(e => {
              return intl.formatMessage({ id: e });
            })}
            value={roomReport.moreMenu}
            onChange={checkOnchage}
          />
        </div>
      </MenuItem>
    </Menu>
  );

  const {
    startTime,
    endTime,
    meetingName,
    pageNo,
    searchData,
    pageSize,
    meetingSearchInfo,
    meetingTreeData
  } = roomReport;
  const { moreMeeting = [] } = meetingSearchInfo;
  const meetingTree = meetingTreeData || { child: [] };
  const data = (searchData.list && datalist(searchData.list)) || [];
  let cols = {
    percent: {
      alias: intl.formatMessage({ id: 'report_percent' }),
      tickInterval: 100
    },
    meeting: { alias: intl.formatMessage({ id: 'report_meeting' }) }
  };
  return (
    <div className="message-body report-room report-container">
      {/*标题*/}
      {/*<div className="messages-first">
        <div className="nav">
          <a>{intl.formatMessage({ id: 'report_meeting_title' })}</a>
        </div>
      </div>*/}
      {/*主体*/}
      <div className="room-report-container">
        <Spin spinning={loading} size="large">
          {/*查询*/}
          <div className="messages-list roomReport room-report-title">
            <div className="messages-title roomReport-head">
              <div className="report-div report-area">
                <label className="report-search-label">
                  {intl.formatMessage({ id: 'report_area' })}
                </label>
                <div className="search-input">
                <span className="menu-border">
                  <i className="iconfont icon-sousuo" />
                  <MoreMeeting
                    meetingTree={meetingTree}
                    intl={intl}
                    placeHolder={intl.formatMessage({
                      id: 'report_room_place_holder'
                    })}
                    selected={moreMeeting}
                    onMeetingChange={v => {
                      // dispatch({type: 'top/setMeetingSearchInfo', meetingSearchInfo: {...meetingSearchInfo, moreMeeting: v}})
                      dispatch({
                        type: 'roomReport/setState',
                        payload: {
                          meetingSearchInfo: {
                            ...meetingSearchInfo,
                            moreMeeting: v
                          }
                        }
                      });
                    }}
                  />
                </span>
                </div>
              </div>
              <div className="report-div report-meeting-name">
                <label className="report-search-label">
                  {intl.formatMessage({ id: 'report_meeting_name' })}
                </label>
                <Input
                  placeholder={intl.formatMessage({ id: 'report_pls_name_f' })}
                  value={meetingName}
                  onChange={e => {
                    dispatch({
                      type: 'roomReport/setState',
                      payload: { meetingName: e.target.value }
                    });
                  }}
                />
              </div>
              <div className="report-div report-date">
                <label className="report-search-label" >
                  {intl.formatMessage({ id: 'report_date' })}
                </label>
                <div>
                  <DatePicker
                    allowClear={false}
                    value={startTime}
                    disabledDate={current => {
                      return (
                        current &&
                        current.startOf('day').valueOf() >=
                        endTime.startOf('day').valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'roomReport/setState',
                        payload: { startTime: e }
                      });
                    }}
                  />
                  ~
                  <DatePicker
                    allowClear={false}
                    disabledDate={current => {
                      return (
                        startTime.valueOf() > current.valueOf() ||
                        current.startOf('day').valueOf() >=
                        moment()
                          .startOf('day')
                          .valueOf()
                      );
                    }}
                    value={endTime}
                    onChange={e => {
                      dispatch({
                        type: 'roomReport/setState',
                        payload: { endTime: e }
                      });
                    }}
                  />
                </div>
              </div>
              <div className="report-div report-btn-group">
                <button
                  className="button_primary"
                  onClick={() => {
                    dispatch({ type: 'roomReport/search' });
                  }}
                >
                  <FormattedMessage id="report_search" />
                </button>
                <button
                  onClick={() => {
                    dispatch({ type: 'roomReport/downloadRoom' });
                  }}
                >
                  <FormattedMessage id="report_download" />
                </button>
              </div>
            </div>
            {/*{false &&*/}
            {/*<div>*/}
            {/*{data && data.length > 0 && <Chart height={400} data={data} scale={cols} forceFit>*/}
            {/*<Axis name="meeting" title={{textStyle: {fill: 'white'}}} label={{textStyle: {fill: 'white'}}}/>*/}
            {/*<Axis name="percent" title={{textStyle: {fill: 'white'}}} label={{textStyle: {fill: 'white'}}}*/}
            {/*position="top"*/}
            {/*/>*/}
            {/*<Tooltip crosshairs={{type: "y"}}/>*/}
            {/*<Geom type="interval" tooltip={true} position="meeting*percent" size={30}*/}
            {/*color={['meeting', ['#E63F50', '#E67E3F', '#DA992A', '#BABB1A', '#AAC37F', '#43A8C6', '#63B1EA', '#E63F50', '#E67E3F', '#DA992A', '#BABB1A']]}/>*/}
            {/*<Guide>*/}
            {/*{searchData.list && textlist(datalist(searchData.list))}*/}
            {/*</Guide>*/}
            {/*</Chart>}*/}
            {/*</div>}*/}
          </div>
          {/*表格*/}

          <div style={{ position: 'relative', paddingBottom: '20px' }}>
            <Dropdown
              overlay={menu}
              visible={roomReport.dropVis}
              onVisibleChange={handleVisibleChange}
            >
              <a
                className="ant-dropdown-link"
                style={{ color: '#333', position: 'absolute', right: '30px' }}
              >
                {intl.formatMessage({ id: 'report_display' })}
              </a>
            </Dropdown>
          </div>

          <div
            className="messages-list roomReport room-report-table"
            style={{ minHeight: '620px' }}
          >
            <div
              className={
                roomReport.moreMenu.length <= 2
                  ? 'tip-case reportTable'
                  : roomReport.moreMenu.length <= 6 &&
                  roomReport.moreMenu.length > 2
                  ? 'tip-case reportTable middle-width-scroll'
                  : 'tip-case reportTable max-width-scroll'
              }
            >
              <div className="meeting-index">
                {intl.formatMessage({ id: 'report_area' })}
              </div>
              <div className="meeting-area">
                {intl.formatMessage({ id: 'report_meeting_name' })}
              </div>
              <div className="meeting-name">
                {intl.formatMessage({ id: 'report_meeting_date' })}
              </div>
              <div className="meeting-num">
                {intl.formatMessage({ id: 'report_meeting_time' })}
              </div>
              <div className="sign-num">
                {intl.formatMessage({
                  id: 'meeting_reserve_message_mail_webex_name'
                })}
              </div>
              {/*<div className="sign-num">{intl.formatMessage({id: 'main_meeting_time_length'})}</div>*/}
              <div className="sign-length">
                {intl.formatMessage({ id: 'report_abnormal_detail_creater' })}
              </div>
              <div className="meeting-occupy">
                {intl.formatMessage({
                  id: 'meeting_reserve_message_mail_webex_holder'
                })}
              </div>
              <div className="meeting-detail">
                {intl.formatMessage({ id: 'main_meeting_attends' })}
              </div>
              <div className="meeting-detail">
                {intl.formatMessage({ id: 'main_meeting_sign' })}
              </div>
              {/*根据获取到的moreMenu在表头进行添加*/}
              {roomReport.moreMenu &&
              roomReport.moreMenu.map((e, index) => {
                return (
                  <div className={'meetingMore'} key={index}>
                    {e}
                  </div>
                );
              })}
            </div>
            <ul
              className={
                searchData.list == undefined
                  ? ''
                  : searchData.list.length == 0
                  ? 'emptyData'
                  : 'messages'
              }
            >
              {searchData.list == undefined
                ? ''
                : searchData.list.length == 0
                  ? intl.formatMessage({ id: 'smart_device_drop_down_no_data' })
                  : ''}
              {searchData.list &&
              tableList(
                searchData.list,
                pageNo,
                dispatch,
                startTime,
                endTime,
                intl,
                roomReport
              )}
            </ul>
            <div
              className="page-cont"
            >
              {searchData.list &&
              searchData.list.length > 0 && (
                <Pagination
                  total={searchData.total || 0}
                  showQuickJumper
                  showSizeChanger
                  pageSize={pageSize || 10}
                  current={pageNo || 1}
                  onShowSizeChange={(page, pageSize) => {
                    dispatch({
                      type: 'roomReport/changePage',
                      payload: { pageNo: page, pageSize: pageSize}
                    });
                  }}
                  onChange={(page, pageSize) => {
                    dispatch({
                      type: 'roomReport/changePage',
                      payload: { pageNo: page, pageSize: pageSize }
                    });
                  }}
                />
              )}
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/RoomReport.js